import React, { useEffect } from "react";
import { useNavigate, useParams } from 'react-router-dom';
import EventAction from "../../Actions/event.service";
import * as waitingAnimationData from '../../Animations/waiting.json'
import Lottie from "react-lottie";
const Waiting = () => {

    const { id } = useParams();
    const navigate = useNavigate();

    useEffect(() => {

        let retryCount = 0;
        const delays = [5000, 10000, 40000, 40000]; //0s 10s 40s 40s

        const fetchOrderStatus = () => {
            console.log('delays', delays);
            if (retryCount >= delays.length) {
                navigate(`/order-failed/${id}`);
                return;
            }
            setTimeout(() => {
                EventAction.getEventOrderStatus(id)
                    .then((res) => {
                        navigate(`/${localStorage.getItem('role')}/${id}`);
                        return;
                    })
                    .catch((err) => {
                        console.log("Error:", err);
                        retryCount++;
                        fetchOrderStatus();
                    });

            }, delays[retryCount]);
        };
        fetchOrderStatus();

    }, [id, navigate]);


    return (
        <>
            <div className="eventbar">
                {/* <h4 className="titleevent">Create Group Gift Event</h4> */}
                <div className="successbar">
                    <Lottie options={{
                        loop: true,
                        autoplay: true,
                        animationData: waitingAnimationData,
                        rendererSettings: {
                            preserveAspectRatio: 'xMidYMid slice'
                        }
                    }}
                        height={160}
                        width={160}
                        isStopped={false} />
                    <h6>Please Wait</h6>
                </div>
            </div>
        </>
    );
}

export default Waiting;